export default{
    STATE_NAME: 'ufp',
    Manifest: {
    },

    ACTION_NAMES: {

        STARTUP: 'STARTUP'

    }
}
